import isEmpty from 'lodash/isEmpty';
import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { FormBlock } from '@/widgets/ServiceFormTemplate';

import { ConditionView, FormSelect } from '@/shared/ui';
import { MultipleFormTextInputFields } from '@/shared/ui/TextInput/MultipleFormTextInputFields';

import { YesNoSelectOptions } from '@/components/Forms/constants';

import { ExtendedCriminalRecordExtractSchema } from '@/modules/iac/pages/services/ExtendedCriminalRecord/model/types';

import { NamesBeforeFieldName } from '@/lib/consts';

export const NameChangedQuestion: React.FC = () => {
  const { control, setValue, resetField } = useFormContext<ExtendedCriminalRecordExtractSchema>();
  const isNameChanged = useWatch<ExtendedCriminalRecordExtractSchema>({
    control,
    name: 'isNameChanged',
  });

  const namesBefore = useWatch<ExtendedCriminalRecordExtractSchema>({
    control,
    name: 'namesBefore',
  });

  useEffect(() => {
    if (isEmpty(isNameChanged)) {
      setValue('isNameChanged', YesNoSelectOptions.NO);
    }
  }, []);

  useEffect(() => {
    if (!isNameChanged) return;

    if (isNameChanged?.id === YesNoSelectOptions.NO.id) {
      resetField('namesBefore');
    } else if (isEmpty(namesBefore)) {
      setValue('namesBefore', [{}]);
    }
  }, [isNameChanged]);

  return (
    <FormBlock title="Зміна прізвища, ім’я та по батькові">
      <FormSelect
        name="isNameChanged"
        label="Чи була зміна прізвища, ім’я або по батькові?"
        control={control}
        options={Object.values(YesNoSelectOptions)}
        defaultValue={YesNoSelectOptions.NO}
        required
      />
      <ConditionView if={isNameChanged?.id === YesNoSelectOptions.YES.id}>
        <MultipleFormTextInputFields
          control={control}
          fieldName="namesBefore"
          addItemLabel="Додати ще зміну ПІБ"
          removeItemLabel="Видалити цю зміну ПІБ"
          inputsProps={[
            {
              name: NamesBeforeFieldName.previousLastName,
              placeholder: 'Введіть прізвище',
              label: 'Попередні прізвище, ім’я та по батькові',
              required: true,
            },
            {
              name: NamesBeforeFieldName.previousName,
              placeholder: 'Введіть імʼя',
              required: true,
            },
            {
              name: NamesBeforeFieldName.previousPatronymic,
              placeholder: 'Введіть по батькові',
            },
          ]}
        />
      </ConditionView>
    </FormBlock>
  );
};
